var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAddIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_12620",
    "data-name": "Group 12620",
    transform: "translate(-130 -539)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11602",
    "data-name": "Group 11602",
    transform: "translate(130 539)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_357",
    "data-name": "Ellipse 357",
    cx: 28,
    cy: 28,
    r: 28,
    transform: "translate(0)",
    fill: "#111"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_44583",
    "data-name": "Path 44583",
    d: "M35.834,10.29H23.1V23.36H14.209V10.29H1.476V2.071H14.209V-11H23.1V2.071H35.834Z",
    transform: "translate(139.979 561.453)",
    fill: "#fff",
    stroke: "#111",
    strokeWidth: 4
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddIcon);
export default __webpack_public_path__ + "static/media/add-icon.bcc1b1d8caaa78fd648f0ab6ae519b0d.svg";
export { ForwardRef as ReactComponent };